import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useMaintenanceContext } from '../../contexts/MaintenanceContext';
import { isWithinMaintenanceWindow } from '../../util/maintenanceTime';
import { MAINTENANCE_CONFIG } from '../../constants/maintenance';
import { useSelector } from 'react-redux';

const MaintenanceGuard = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const { maintenanceSchedule } = useMaintenanceContext();
  const lang = window.appLang;

  useEffect(() => {
    if (!maintenanceSchedule) return;

    const URL = '/' + lang + MAINTENANCE_CONFIG.MAINTENANCE_ROUTE;
    const { StartDate, EndDate } = maintenanceSchedule;
    
    const checkAndRedirect = () => {
      if (isWithinMaintenanceWindow(StartDate, EndDate) && location.pathname !== URL) {
        sessionStorage.setItem(MAINTENANCE_CONFIG.REDIRECT_STORAGE_KEY, location.pathname);
        history.push(URL);
      }
      else if (!isWithinMaintenanceWindow(StartDate, EndDate) && location.pathname === URL) {
        const redirectPath = sessionStorage.getItem(MAINTENANCE_CONFIG.REDIRECT_STORAGE_KEY) || '/';
        sessionStorage.removeItem(MAINTENANCE_CONFIG.REDIRECT_STORAGE_KEY);
        history.push(redirectPath);
      }
    };

    // Check immediately
    checkAndRedirect();

    // Set up interval to check periodically for automatic redirects
    const interval = setInterval(checkAndRedirect, MAINTENANCE_CONFIG.CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [maintenanceSchedule, location.pathname, history]);

  return <>{children}</>;
};

MaintenanceGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MaintenanceGuard;
